import React from 'react'
import "./Table.css"


 const TableData =[
    {
        name:"Abdullahi Bashir",
        iid:"INV-0234",
        amount:"$50",
        status:"Completed",
        date:"18/09/2024"
    },
    {
        name:"Fatima Salis",
        iid:"INV-4321",
        amount:"$100",
        status:"Pending",
        date:"18/09/2024"
    },
    {
        name:"Abubakar said",
        iid:"INV-3421",
        amount:"$70",
        status:"Cancelled",
        date:"18/09/2024"
    },
]

const Table = () => {
  return (
   <div className="table1">
        <table>
          <thead>
            <th>Name</th>
            <th>Invoice ID</th>
            <th>Amount</th>
            <th>Status</th>
            <th>Date</th>
          </thead>
          <tbody>
            {TableData.map((row) => (
              <tr>
                <td>{row.name}</td>
                <td>{row.iid}</td>
                <td>{row.amount}</td>
                <td 
                  style={{
                    backgroundColor:
                      row.status === "Completed"
                        ? "#47ec4ca0"
                        : row.status === "Pending"
                        ? "#e7b84997"
                        : row.status === "Cancelled"
                        ? "#ff77779c"
                        : "white",
                   
                    textAlign:'center',
                    borderRadius:'30px',
                    border:'2px solid #fff'
                  }}
                >
                  {row.status}
                </td>
                <td>{row.date}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
  )
}

export default Table